/**
 * Two crossfades on the product page:
 * 1. Add to Cart <-> "Notify When Back in Stock" (driven by variant
 *    availability, via .product-form__cta-stack.is-out-of-stock)
 * 2. "Notify When Back in Stock" <-> two icon-only links (Instagram,
 *    email signup), driven by a click on the notify button
 */
(function () {
  function initNotifyBackInStock(root) {
    var toggleBtn = root.querySelector('.notify-toggle-btn');
    var iconsWrapper = root.querySelector('.notify-icons-wrapper');
    if (!toggleBtn || !iconsWrapper) return;

    iconsWrapper.hidden = false;

    function showIcons() {
      toggleBtn.classList.add('is-fading-out');
      iconsWrapper.classList.add('is-visible');
    }

    function resetToButton() {
      toggleBtn.classList.remove('is-fading-out');
      iconsWrapper.classList.remove('is-visible');
    }

    toggleBtn.addEventListener('click', showIcons);

    // Expose the reset so the outer variant-change handler below can
    // call it when switching between sold-out sizes.
    root._notifyReset = resetToButton;
  }

  function initCtaStacks() {
    document.querySelectorAll('[data-cta-stack]').forEach(function (stackEl) {
      var sectionId = stackEl.dataset.sectionId;
      var notifyEl = stackEl.querySelector('.notify-back-in-stock');

      if (notifyEl) initNotifyBackInStock(notifyEl);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          if (event.data.sectionId !== sectionId) return;
          var variant = event.data.variant;

          if (!variant) {
            stackEl.classList.remove('is-out-of-stock');
            return;
          }

          stackEl.classList.toggle('is-out-of-stock', !variant.available);

          // Switching to a different sold-out size: reset back to the
          // "Notify When Back in Stock" button rather than staying on
          // whatever icon state was left over from the previous size.
          if (notifyEl && typeof notifyEl._notifyReset === 'function') {
            notifyEl._notifyReset();
          }
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCtaStacks);
  } else {
    initCtaStacks();
  }
})();